import styled from 'styled-components';
import { themeGet } from '@upright/ui/common/generic/theme/custom-theme';

export const NirFormulaWithLightText = (props: { positiveText: string; negativeText: string }) => {
  return (
    <span>
      {'('}
      <LightPositiveHighlightText>{props.positiveText}</LightPositiveHighlightText> -{' '}
      <LightNegativeHighlightText>{props.negativeText}</LightNegativeHighlightText>
      {')'} / <LightPositiveHighlightText>{props.positiveText}</LightPositiveHighlightText>
    </span>
  );
};

export const NisFormulaWithLightText = (props: { positiveText: string; negativeText: string }) => {
  return (
    <span>
      <LightPositiveHighlightText>{props.positiveText}</LightPositiveHighlightText> -{' '}
      <LightNegativeHighlightText>{props.negativeText}</LightNegativeHighlightText>
    </span>
  );
};

export const NirFormulaWithDarkText = (props: { positiveText: string; negativeText: string }) => {
  return (
    <span>
      {'('}
      <DarkPositiveHighlightText>{props.positiveText}</DarkPositiveHighlightText> -{' '}
      <DarkNegativeHighlightText>{props.negativeText}</DarkNegativeHighlightText>
      {')'} / <DarkPositiveHighlightText>{props.positiveText}</DarkPositiveHighlightText>
    </span>
  );
};

export const NisFormulaWithDarkText = (props: { positiveText: string; negativeText: string }) => {
  return (
    <span>
      <DarkPositiveHighlightText>{props.positiveText}</DarkPositiveHighlightText> -{' '}
      <DarkNegativeHighlightText>{props.negativeText}</DarkNegativeHighlightText>
    </span>
  );
};

export const DarkPositiveHighlightText = styled.span`
  color: ${themeGet('colorSchemes.light.colors.impact.positive.text.dark')};
`;

export const DarkNegativeHighlightText = styled.span`
  color: ${themeGet('colorSchemes.light.colors.impact.negative.text.dark')};
`;

export const LightPositiveHighlightText = styled.span`
  color: ${themeGet('colorSchemes.light.colors.impact.positive.text.light')};
`;

export const LightNegativeHighlightText = styled.span`
  color: ${themeGet('colorSchemes.light.colors.impact.negative.text.light')};
`;
